import { fetchAuthSession } from 'aws-amplify/auth';
import { LocalStorageKey } from '../vendor/local';
import { captureException } from '../vendor/sentry';

/**
 * https://docs.amplify.aws/gen1/react/build-a-backend/auth/manage-user-session/
 */
export const fetchSession = async (forceRefresh = false) => {
  try {
    const session = await fetchAuthSession({ forceRefresh });
    const { idToken } = session.tokens ?? {};
    // debugger
    localStorage.setItem(LocalStorageKey.Token, idToken?.toString() ?? '');
    localStorage.setItem(LocalStorageKey.TokenExp, ((idToken?.payload?.exp || 0) * 1000).toString());
  } catch (error) {
    captureException(error, { source: 'fetchSession' });
  }
}